<template>
  <div>
    <div class="vx-row flex flex-col md:flex-row space-x-4 bg-white p-2 ">

      <vs-popup :title="$t('ResolveFlaggedStepTitle')" :active.sync="InStepResolveMode" v-if="InStepResolveMode">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            {{ $t('CommentLabel') }}
            <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;"
                      :label-placeholder="$t('CommentLabel')"
                      v-model="resolveComment" />
          </div>
          <div class="vx-col w-full mb-base">
            <vs-checkbox v-model="notifyReporter">
              {{ $t('NotifyReporter') }},
            </vs-checkbox>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mb-base">
            <vs-button @click="ResolveMarkedStep">{{ $t('MarkAsResolved') }}</vs-button>
          </div>
        </div>
      </vs-popup>

      <vs-popup :title="$t('SaveSearchQueryTitle')" :active.sync="InSaveQueryMode" s v-if="InSaveQueryMode">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            {{ $t('NameLabel') }}
            <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;"
                      :label-placeholder="$t('NameLabel')"
                      v-model="query_name" />
          </div>

          <div class="vx-col w-full mb-base">
            {{ $t('UrlLabel') }}
            <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;"
                      :label-placeholder="$t('UrlLabel')"
                      v-model="query_url" />
          </div>
        </div>
        <div v-if="!InQueryPage" @active.sync="!InQueryPage" class="vx-row">
          <div class="vx-col md:w-1/2 w-full mb-base">
            <vs-button @click="SaveSearchQuery">{{ $t('Save') }}</vs-button>
          </div>
        </div>
      </vs-popup>


      <vs-popup :title="$t('EditSearchQueryTitle')" :active.sync="InQueryEditMode" s v-if="InQueryEditMode">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            {{ $t('NameLabel') }}
            <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;"
                      :label-placeholder="$t('NameLabel')"
                      v-model="query_name" />
          </div>

          <div class="vx-col w-full mb-base">
            {{ $t('UrlLabel') }}
            <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;"
                      :label-placeholder="$t('UrlLabel')"
                      v-model="query_url" />
          </div>
        </div>
        <div v-if="InQueryEditMode" @active.sync="InQueryPage" class="vx-row">
          <div class="vx-col md:w-1/2 w-full mb-base">
            <vs-button @click="EditSearchQuery">{{ $t('Save') }}</vs-button>
          </div>
        </div>
      </vs-popup>

      <h1 v-if="InQueryPage" @active.sync="InQueryPage">{{queryName}}</h1>
      <div class="md:w-1/6 ml-2" v-if="!InQueryPage || InEditFiltersMode" @active.sync="!InQueryPage || InEditFiltersMode">
        {{ $t('FilterBySpaces') }}
        <v-select multiple
                  :placeholder="$t('Select') + '...'"
                  label="breadcrumbTile"
                  :closeOnSelect="false"
                  v-model="selectedSpace"
                  @input="LoadAllAppropriateDataForSpacesAndOnboardings()"
                  :reduce="(space) => space.id"
                  push-tags
                  :options="spaceList" />
      </div>
      <div class="md:w-1/6  ml-2" v-if="!InQueryPage  || InEditFiltersMode" @active.sync="!InQueryPage  || InEditFiltersMode">
        {{ $t('FilterByOnboardings') }}
        <v-select multiple
                  :placeholder="$t('Select') + '...'"
                  label="name"
                  :closeOnSelect="false"
                  v-model="selectedOnboarding"
                  @input="LoadAllAppropriateDataForSpacesAndOnboardings()"
                  :reduce="(item) => item.id"
                  push-tags
                  :options="onboardingList" />
      </div>
      <div class="md:w-1/6 ml-2" v-if="!InQueryPage || InEditFiltersMode" @active.sync="!InQueryPage || InEditFiltersMode">
        {{ $t('FilterByRoles') }}
        <v-select multiple
                  :placeholder="$t('Select') + '...'"
                  label="name"
                  :closeOnSelect="false"
                  v-model="selectedRole"
                  :reduce="(item) => item.id"
                  @input="LoadHeatMapAndMetricsData(),LoadUserWithMostaCompletedOnboardings()"
                  push-tags
                  :options="rolesList" />
      </div>

      <div class="md:w-1/6 ml-2" v-if="!InQueryPage || InEditFiltersMode" @active.sync="!InQueryPage || InEditFiltersMode">
        {{ $t('DateRange') }}
        <v-select :placeholder="$t('Select') + '...'"
                  label="label"
                  :closeOnSelect="true"
                  v-model="date_range"
                  :clearable="false"
                  :reduce="(item) => item.days"
                  @input="LoadHeatMapAndMetricsData(),LoadUserWithMostaCompletedOnboardings()"
                  :options="dateRangeOptions" />
      </div>
      <vs-button v-if="$acl.check('admin') && !InQueryPage" @active.sync="!InQueryPage" @click="OpenSaveSearchQuery" class="ml-5 h-10 mt-5">{{ $t('SaveThisSearchQuery') }}</vs-button>
      <div>
          <vs-button v-if="InEditFiltersMode" @click="EditSearchQueryFilters" class="ml-5 h-10 mt-5">{{ $t('SaveFilters') }}</vs-button>
          <vs-button v-if="InEditFiltersMode" @click="CloseFilterEdit" class="ml-5 h-10 mt-5">X</vs-button>
      </div>
      <vs-dropdown v-if="InQueryPage && !InEditFiltersMode" id="menu-dropdown" vs-trigger-click class="pointer" style="margin-left: auto;">
        <FeatherIcon class="tool pointer" :title="$t('Options')" icon="MenuIcon" style="position:unset; cursor:pointer;"></FeatherIcon>
        <vs-dropdown-menu style="width:120px;">
          <vs-dropdown-item v-if="$acl.check('admin')" @click="DeleteSearchQuery">{{ $t('DeleteThisSearchQuery') }}</vs-dropdown-item>
          <vs-dropdown-item v-if="$acl.check('admin')" @click="OpenEditQueryMenu">{{ $t('EditNameAndUrl') }}</vs-dropdown-item>
          <vs-dropdown-item v-if="$acl.check('admin')" @click="OpenFilterEdit">{{ $t('EditFilters') }}</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>


    </div>

    <div class="metrics-grid">
      <MetricCard :title="$t('TotalSOPs')" :stat="totalSOPs"></MetricCard>
      <MetricCard :title="$t('TotalUsers')" :stat="totalUsers"></MetricCard>
      <MetricCard :title="$t('CompletionRate')" :stat="completionRate + '%'"></MetricCard>
      <MetricCard :title="$t('InProgressLabel')" :stat="inProgress"></MetricCard>
      <MetricCard :title="$t('NotStarted')" :stat="notStarted"></MetricCard>
      <MetricCard :title="$t('EstimatedHoursSaved')" :stat="timeSavedByOnboardings"></MetricCard>
      <MetricCard :title="$t('DocumentationRequests')" :stat="documentationRequests"></MetricCard>
    </div>
    <div class="charts-grid">
      <ChartCard :key="reloadKey" :completed="completed" :in_progress="inProgress" :not_started="notStarted"></ChartCard>
      <TrendChart :key="reloadKeyTrend" :completed="completed_trend" :in_progress="started_trend" :labels="labels"></TrendChart>
    </div>

    
    <div class="vx-col w-full mb-base mt-5">
      <skill-matrix v-model="assignedSkills"
                    :people="people"
                    :sops="sops"
                    :heatmap="heatMap"
                    title="Skill Matrix"
                    available-tab-label="Available Skills"
                    assigned-tab-label="Assigned Skills" />
    </div>
    <div class="grid-bottom w-full mb-base mt-5">
      <div>
        <vx-card>
          <span class="p-3 inline-flex rounded-full feather-icon select-none relative text-danger mb-4" style="background: rgba(var(--vs-danger),.15); height: 45px;">
            <FeatherIcon icon="FlagIcon" style="height:1em;"></FeatherIcon>
          </span>
          <h5 class="mb-2" style="font-weight:900; display:inline-block; margin-left:20px; margin-bottom:50px;">
            {{ $t('FlaggedSteps') }}
          </h5>
          <div v-for="(item, idx) in flaggedItems" :key="'flag_' + idx" class="step-box">
            <vs-avatar src="" style="bottom:5px; right:5px; display:inline-block; float:left;" color="danger" text-color="white" :text="item.Items.length.toString()" />
            <div style="display: inline-block; float: left; max-width: calc(95% - 45px);">
              <a target="_blank" :href="'/pages/pdf-view?oid=' + item.OnboardingId + '&stepId=' + item.StepId">{{item.OnboardingName}} (marked by {{item.UniqueUsers}} user/s)</a> <br />
              <!--{{item.User}}<br />-->
              <!--<em>{{item.Reason}}</em><br />-->
            </div>
            <div class="expandTools" style="float:right">
              <button class="icon-button chevron-down" @click="ExpandMarkedSteps($event)" :title="$t('Expand')">
                <i class="fas fa-chevron-down expand-icon"></i>
              </button>
              <button class="icon-button chevron-up" @click="CollapseMarkedSteps($event)" :title="$t('Collapse')">
                <i class="fas fa-chevron-up expand-icon"></i>
              </button>
            </div>
            <div style="clear:both; margin-bottom:10px;"></div>

            <div v-for="(subItem, subIdx) in item.Items" :key="'subitem_' + subIdx" class="step-box-inner">
              <vs-avatar :src="subItem.AvatarUrl" style="bottom:5px; right:5px; display:inline-block; float:left;" color="danger" text-color="white" :text="getFriendlyUserName(subItem)" />
              <div style="display: inline-block; float: left; max-width: calc(95% - 45px);">
                <!--<a target="_blank" :href="'/pages/pdf-view?oid=' + item.OnboardingId + '&stepId=' + subItem.StepId">{{item.OnboardingName}}</a> <br />-->
                <!--{{item.User}}<br />-->
                <a target="_blank" :href="'/pages/pdf-view?oid=' + item.OnboardingId + '&stepId=' + subItem.StepId">{{subItem.Reason}}</a>
              </div>
              <div style="float:right">
                <FeatherIcon title="Resolve" @click="OpenStepResolveMenu(subItem.Id,subIdx,item.OnboardingId)" class="cursor-pointer" style="color:blueviolet" icon="CheckCircleIcon"></FeatherIcon>
              </div>
              <div style="clear:both; margin-bottom:10px;"></div>
            </div>
          </div>
        </vx-card>
      </div>
      <div>
        <vx-card>
          <span class="p-3 inline-flex rounded-full feather-icon select-none relative text-success mb-4" style="background: rgba(var(--vs-success),.15); height: 45px;">
            <FeatherIcon icon="CheckIcon" style="height:1em;"></FeatherIcon>
          </span>
          <h5 class="mb-2" style="font-weight:900; display:inline-block; margin-left:20px; margin-bottom:50px;">
            {{ $t('UsersCompletedMostOnboardings') }}
          </h5>
          <div v-if="mostCompletedOnboardings.length != 0" v-for="(item, idx) in mostCompletedOnboardings" :key="'flag_' + idx" style="margin-top:10px;">
            <vs-avatar :src="item.User.avatarUrl" style="bottom:5px; right:5px; display:inline-block; float:left;" color="success" text-color="white" :text="getFriendlyUserName(item.User)" />
            <div style="display: inline-block; float: left; max-width: calc(95% - 45px);">
              <p>{{ item.User.FirstName && item.User.LastName ? `${item.User.FirstName} ${item.User.LastName}` : item.User.UserName }}</p>
              <em>{{ $t('CompletedCountForPeriod', { count: item.Count }) }}</em><br />
            </div>
            <div style="clear:both; margin-bottom:10px;"></div>
          </div>
          <div v-else>{{ $t('NoDataForThisOnboarding') }}</div>
        </vx-card>
      </div>

      <div style="color:cornflowerblue">
        <vx-card>
          <span class="p-3 inline-flex rounded-full feather-icon select-none relative text-info mb-4" style="background: rgba(var(--vs-info),.15); height: 45px;">
            <FeatherIcon icon="StarIcon" style="height:1em;"></FeatherIcon>
          </span>
          <h5 class="mb-2" style="font-weight:900; display:inline-block;color:cornflowerblue; margin-left:10px; margin-bottom:50px; ">
            {{ $t('SOPStats') }}
          </h5>
          <div v-if='feedbackData.length != 0' v-for="(item, idx) in feedbackData" :key="'flag_' + idx" class="step-box">
            <vs-avatar src="" size="40" style="bottom:5px; right:5px; display:inline-block; float:left;" color="cornflowerblue" text-color="white" :text="Math.round(item.TimeSaved).toString() + 'h.'" />
            <div style="display: inline-block; float: left; max-width: calc(95% - 45px);">
              <h4 style="color: black;"><a target="_blank" style="color:cornflowerblue !important; cursor:pointer !important;" :href="'/pages/pdf-view?oid=' + item.OnboardingId">{{item.OnboardingName}}</a>
              <br />
              </h4>
              {{ $t('RatingsCount', { count: item.RatingsCount }) }}<br />
              {{ $t('EstimatedHoursSavedShort', { hours: item.TimeSaved }) }}<br/>
            </div>
            <div class="expandTools" style="float:right">
              <button class="icon-button chevron-down" @click="ExpandMarkedSteps($event)" title="Expand marked steps for this onboading...">
                <i class="fas fa-chevron-down expand-icon"></i>
              </button>
              <button class="icon-button chevron-up" @click="CollapseMarkedSteps($event)" title="Collapse marked steps for this onboading...">
                <i class="fas fa-chevron-up expand-icon"></i>
              </button>
            </div>
            <div style="clear:both; margin-bottom:10px;"></div>

            <div v-for="(subItem, subIdx) in item.Comments" :key="'subitem_' + subIdx" class="step-box-inner">
              <vs-avatar :src="subItem.AvatarUrl" style="bottom:5px; right:5px; display:inline-block; float:left;" color="cornflowerblue" text-color="white" :text="getFriendlyUserName(subItem)" />
              <div style="display: inline-block; float: left; max-width: calc(95% - 45px);">
                {{ $t('Comment') }}
                <!--<a target="_blank" :href="'/pages/pdf-view?oid=' + item.OnboardingId + '&stepId=' + subItem.StepId">{{item.OnboardingName}}</a> <br />-->
                <!--{{item.User}}<br />-->
                {{subItem.Comment}}
              </div>
              <div style="clear:both; margin-bottom:10px;"></div>
            </div>
          </div>
          <div v-else>
            {{ $t('NoItemsToShow') }}
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
  import { AclRule } from 'vue-acl'
  import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
  import analyticsData from '@/views/ui-elements/card/analyticsData.js'
  import TCVelikClient from '@/TCVelikClient/TCVelikClient';
  import FeatherIcon from "@/components/FeatherIcon.vue";
  import vSelect from "vue-select";
  import VueApexCharts from 'vue-apexcharts'
  import apexChatData from '@/views/charts-and-maps/charts/apex-charts/apexChartData.js'
  import SkillMatrix from '@/views/components/organisms/skillmatrix/SkillMatrix.vue';
  import MetricCard from '@/views/components/organisms/analytics/MetricCard.vue';
  import ChartCard from '@/views/components/organisms/analytics/ChartCard.vue';
  import TrendChart from '@/views/components/organisms/analytics/TrendChart.vue';

  export default {
    data() {
      return {
        assignedSkills: [],
        onboardingsOpenedData: null,
        lastOpenedOnboardings: null,
        heatMap: null,
        filtedOnboardings: null,
        filtedSelect: null,
        query_name: null,
        InQueryPage: false,
        InQueryEditMode:false,
        query_url: null,
        queryName:"Default title",
        onboardingList: [],
        rolesList: null,
        resolveComment: "",
        stepOnboardingId: null,
        spaceList: null,
        stepIdToResolve: null,
        stepIdToResolveIndex: 0,
        InStepResolveMode: false,
        InEditFiltersMode:false,
        InSaveQueryMode: false,
        tempSpaceList: null,
        emailsList: null,
        selectedOnboarding: [],
        feedbackData:[],
        timeSavedByOnboardings:0,
        totalSOPs: 0,
        totalUsers: 0,
        completionRate: 0,
        completed: 0,
        labels: [],
        mostCompletedOnboardings: [],
        completed_trend: [],
        started_trend: [],
        notStarted: 0,
        inProgress: 0,
        reloadKey: 0,
        reloadKeyTrend: 0,
        notifyReporter:false,
        selectedRole: [],
        selectedSpace: [],
        date_range: 30,
        latestSteps: null,
        itemsPerPage: 5,
        flaggedItems: [],
        latestCompletedOnboardings: [],
        analyticsData: analyticsData,
        apexChatData: apexChatData,
        heatMapHeight: 700,
        openedStats: {
          Total: 0,
          Title: "Weekly openings",
          series: [{
            name: 'Opened',
            data: [0, 0, 0, 0]
          }],
          chartOptions: {
            grid: {
              show: false,
              padding: {
                left: 0,
                right: 0
              }
            },
            chart: {
              toolbar: {
                show: false,
              },
              sparkline: {
                enabled: true
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'smooth',
              width: 2.5
            },
            fill: {
              type: 'gradient',
              gradient: {
                shadeIntensity: 0.9,
                opacityFrom: 0.7,
                opacityTo: 0.5,
                stops: [0, 80, 100]
              }
            },
            xaxis: {
              type: 'numeric',
              lines: {
                show: false,
              },
              axisBorder: {
                show: false,
              },
              labels: { show: false }
            },
            yaxis: [{
              y: 0,
              offsetX: 0,
              offsetY: 0,
              padding: { left: 0, right: 0 },
            }],
            tooltip: {
              x: { show: false }
            },
          },
        },

        completedStats: {
          Total: 0,
          Title: "Weekly completion",
          series: [{
            name: 'Completed',
            data: [0, 0, 0, 0]
          }],
          chartOptions: {
            grid: {
              show: false,
              padding: {
                left: 0,
                right: 0
              }
            },
            chart: {
              toolbar: {
                show: false,
              },
              sparkline: {
                enabled: true
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'smooth',
              width: 2.5
            },
            fill: {
              type: 'gradient',
              gradient: {
                shadeIntensity: 0.9,
                opacityFrom: 0.7,
                opacityTo: 0.5,
                stops: [0, 80, 100]
              }
            },
            xaxis: {
              type: 'numeric',
              lines: {
                show: false,
              },
              axisBorder: {
                show: false,
              },
              labels: { show: false }
            },
            yaxis: [{
              y: 0,
              offsetX: 0,
              offsetY: 0,
              padding: { left: 0, right: 0 },
            }],
            tooltip: {
              x: { show: false }
            },
          },
        },

        flaggedStats: {
          Total: 0,
          Title: "Flagged",
          series: [{
            name: 'Flagged',
            data: [0, 0, 0, 0]
          }],
          chartOptions: {
            grid: {
              show: false,
              padding: {
                left: 0,
                right: 0
              }
            },
            chart: {
              toolbar: {
                show: false,
              },
              sparkline: {
                enabled: true
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'smooth',
              width: 2.5
            },
            fill: {
              type: 'gradient',
              gradient: {
                shadeIntensity: 0.9,
                opacityFrom: 0.7,
                opacityTo: 0.5,
                stops: [0, 80, 100]
              }
            },
            xaxis: {
              type: 'numeric',
              lines: {
                show: false,
              },
              axisBorder: {
                show: false,
              },
              labels: { show: false }
            },
            yaxis: [{
              y: 0,
              offsetX: 0,
              offsetY: 0,
              padding: { left: 0, right: 0 },
            }],
            tooltip: {
              x: { show: false }
            },
          },
        },


        engagedStats: {
          Total: 0,
          Title: "Engaged Users",
          series: [{
            name: 'Engaged',
            data: [0, 0, 0, 0]
          }],
          chartOptions: {
            grid: {
              show: false,
              padding: {
                left: 0,
                right: 0
              }
            },
            chart: {
              toolbar: {
                show: false,
              },
              sparkline: {
                enabled: true
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'smooth',
              width: 2.5
            },
            fill: {
              type: 'gradient',
              gradient: {
                shadeIntensity: 0.9,
                opacityFrom: 0.7,
                opacityTo: 0.5,
                stops: [0, 80, 100]
              }
            },
            xaxis: {
              type: 'numeric',
              lines: {
                show: false,
              },
              axisBorder: {
                show: false,
              },
              labels: { show: false }
            },
            yaxis: [{
              y: 0,
              offsetX: 0,
              offsetY: 0,
              padding: { left: 0, right: 0 },
            }],
            tooltip: {
              x: { show: false }
            },
          },
        },
        documentationRequests: 0,
      }
    },
    computed: {
      dateRangeOptions() {
        return [
          { label: this.$t('Last7Days'), days: 7 },
          { label: this.$t('Last30Days'), days: 30 },
          { label: this.$t('Last90Days'), days: 90 },
          { label: this.$t('LastYear'), days: 365 }
        ];
      }
    },
    watch: {
      '$route.params.slug'(newUrl, oldUrl) {
        this.selectedSpace = []
        this.selectedOnboarding = []
        this.selectedRole = []
        if (newUrl !== oldUrl && newUrl != null) {
          this.InQueryPage = true;
          this.LoadSeachQuery();
        }
        else {
          this.InQueryPage = false
          this.LoadHeatMapAndMetricsData()
        }

      },
      date_range(newVal, oldVal) {
        this.loadDocumentationRequests();
      },
    },

    mounted() {
      const date = new Date();
      const month = date.getMonth() + 1;
      if (this.$route.query.onboardingId) {
        this.selectedOnboarding.push(this.$route.query.onboardingId * 1);
      }
      if (this.$route.params.slug) {
        this.InQueryPage = true;
        this.LoadSeachQuery();
      }
      else {
        this.LoadHeatMapAndMetricsData();
      }

      this.LoadBlockedLatestSteps();
      this.LoadBlockedLatestOnboardings();
      this.LoadUsersAndRoles();
      this.LoadOnboardings();
      this.LoadSpaces();
      this.LoadUserWithMostaCompletedOnboardings();
      this.LoadFeedbackStatisticsData();
      this.loadDocumentationRequests();
    },

    components: {
      StatisticsCardLine,
      FeatherIcon,
      VueApexCharts,
      vSelect,
      SkillMatrix,
      MetricCard,
      ChartCard,
      TrendChart
    },
    methods: {
      LoadOnboardingData(onboardingType, selectedMonth, statCardName) {
        var instance = this;
        TCVelikClient.GetRelative("/api/analytics/GetOnboardingData?OnboardingType=" + onboardingType + "&SelectedMonth=" + selectedMonth).then(function (response) {
          if (response) {
            instance[statCardName].series[0].data = response.data.OpenedPerWeek.map(itm => itm.Count) || null
            instance[statCardName].Total = response.data.NumberOfOpenedOrClosedOnboardings;
          }
        }).catch(err => {
          alert(this.$t('ErrorFetchingData'))
        });
      },

      GetBreadcrumb(item) {
        if (item.parentId != null) {
          var parent = this.tempSpaceList.find(element => element.id === item.parentId);
          return this.GetBreadcrumb(parent) + " > " + item.title
        }
        else {
          return item.title
        }

      },
        LoadHeatMapAndMetricsData() {
        if (this.InEditFiltersMode == true) return 
        var instance = this;

        TCVelikClient.PostRelative("/api/analytics/GetHeatMapAndMetricsData", {
          SpaceIds: instance.selectedSpace, 
          OnboardingIds: instance.selectedOnboarding, 
          RoleIds: instance.selectedRole, 
          Days: instance.date_range,
        }).then(function (response) {
          if (response && response.data && response.data.result && response.data.result.length > 0) {
            // Get space mappings from response
            const spaceMappings = response.data.space_mappings || [];
            
            // Extract unique people from all data points
            const allPeople = new Set();
            response.data.result.forEach(item => {
              if (item.data) {
                item.data.forEach(point => {
                  if (point.x) {
                    allPeople.add(point.x);
                  }
                });
              }
            });

            instance.people = Array.from(allPeople);
            
            // Create a map of onboardingId to space
            const onboardingToSpaceMap = new Map();
            spaceMappings.forEach(space => {
              space.onboardingIds.forEach(onboardingId => {
                onboardingToSpaceMap.set(onboardingId, {
                  id: space.spaceId,
                  title: space.spaceTitle
                });
              });
            });

            // Group heatmap data by space
            const groupedHeatmap = spaceMappings.map(space => {
              const spaceSops = response.data.result.filter(item => 
                space.onboardingIds.includes(item.id)
              );
              
              return {
                id: `s-${space.spaceId}`, // Prefix space IDs with 's-'
                name: space.spaceTitle,
                description: space.spaceDescription || '',
                isSpace: true,
                expanded: true,
                breadcrumb: space.spaceTitle.split('/'), // Split the title by '/' to create breadcrumb
                data: instance.people.map(person => ({ 
                  x: person, 
                  y: 0,
                  _id: `s-${space.spaceId}-${person}` // Unique ID for space-person pair
                })), // Initialize data for space row
                children: spaceSops.map(sop => {
                  // Ensure each data point has a unique ID
                  const sopData = sop.data.map(point => ({
                    ...point,
                    _id: `o-${sop.id}-${point.x}` // Unique ID for sop-person pair
                  }));
                  
                  return {
                    ...sop,
                    id: `o-${sop.id}`, // Prefix onboarding IDs with 'o-'
                    isSpace: false,
                    parentId: `s-${space.spaceId}`, // Use prefixed parent ID
                    data: sopData.length > 0 ? sopData : instance.people.map(person => ({ 
                      x: person, 
                      y: 0,
                      _id: `o-${sop.id}-${person}` // Unique ID for sop-person pair
                    })) // Use existing data or initialize
                  };
                })
              };
            });

            // Calculate height based on total items (spaces + their SOPs)
            const totalItems = groupedHeatmap.reduce((acc, space) => acc + 1 + space.children.length, 0);
            instance.heatMapHeight = (totalItems * 25) + 300;
            
            // Flatten the structure for the heatmap component and ensure unique keys
            instance.heatMap = groupedHeatmap.flatMap((space, spaceIndex) => [
              { 
                ...space, 
                children: undefined,
                _key: `space-${spaceIndex}` // Add unique key for space
              },
              ...space.children.map((sop, sopIndex) => ({
                ...sop,
                _key: `sop-${spaceIndex}-${sopIndex}` // Add unique key for SOP
              }))
            ]);

            // Log the first few items to verify data structure
            console.log('First space data:', JSON.stringify(groupedHeatmap[0], null, 2));
            console.log('First SOP data:', JSON.stringify(groupedHeatmap[0]?.children[0], null, 2));

            // Update metrics
            instance.totalSOPs = response.data.result_metrics.total_sops;
            instance.completionRate = response.data.result_metrics.completion_rate;
            instance.notStarted = response.data.result_metrics.not_started;
            instance.inProgress = response.data.result_metrics.in_progress;
            instance.completed = response.data.result_metrics.completed;
            instance.totalUsers = response.data.result_metrics.total_users;
            instance.timeSavedByOnboardings = response.data.result_metrics.time_saved;

            // Update trends
            var trends = response.data.result_metrics_trend;
            if (Object.keys(trends).length) {
              instance.completed_trend = trends.map(item => item.CompletedCount);
              instance.started_trend = trends.map(item => item.StartedCount);
              instance.labels = trends.map(item => item.Label);
            }

            instance.reloadCharts();
          }
        }).catch(err => {
          console.error('Error fetching heatmap data:', err);
          instance.$vs.notify({
            title: instance.$t('Failed'),
            text: instance.$t('ErrorFetchingHeatmap'),
            color: 'danger',
            position: 'top-center'
          });
        });
      },
      reloadCharts() {
        this.reloadKey += 1
        this.reloadKeyTrend += 1
      },

      ExpandMarkedSteps(event) {
        event.target.closest(".step-box").classList.add('expanded')
      },

      OpenEditQueryMenu() {
        this.InQueryEditMode = true;
      },

      OpenFilterEdit() {
        this.InEditFiltersMode = true;
      },

        CloseFilterEdit() {
            this.InEditFiltersMode = false;
        },

      CollapseMarkedSteps(event) {
        event.target.closest(".step-box").classList.remove('expanded')
      },

      LoadAllAppropriateDataForSpacesAndOnboardings() {
        this.LoadHeatMapAndMetricsData()
        this.LoadBlockedLatestSteps()
        this.LoadFeedbackStatisticsData()
        this.LoadUserWithMostaCompletedOnboardings()
      },

      LoadFlaggedStats(selectedMonth, statCardName) {
        var instance = this;
        TCVelikClient.GetRelative("/api/analytics/GetFlaggedData?SelectedMonth=" + selectedMonth)
          .then(function (response) {
            if (response) {
              instance[statCardName].series[0].data = response.data.OpenedPerWeek.map(itm => itm.Count) || null
              instance[statCardName].Total = response.data.NumberOfOpenedOrClosedOnboardings;
            }
          }).catch(err => {
            alert("There was an error fetching the data.")
          });
      },
      LoadEngagedUsers(selectedMonth, statCardName) {
        var instance = this;
        TCVelikClient.GetRelative("/api/analytics/GetEngagedUsers?SelectedMonth=" + selectedMonth)
          .then(function (response) {
            if (response) {
              instance[statCardName].series[0].data = response.data.OpenedPerWeek.map(itm => itm.Count) || null
              instance[statCardName].Total = response.data.NumberOfOpenedOrClosedOnboardings;
            }
          }).catch(err => {
            alert("There was an error fetching the data.")
          });
      },
        LoadLatestSteps() {
        if (this.InEditFiltersMode == true) return 
        var instance = this;
        TCVelikClient.PostRelative("/api/analytics/GetLatestSteps?type=0", {
          SpaceIds: instance.selectedSpace, OnboardingIds: instance.selectedOnboarding, RoleIds: instance.selectedRole, Days: instance.date_range
        }).then(function (response) {
          if (response) {
            instance.latestSteps = response.data || null
          }
        }).catch(err => {
          alert(this.$t('ErrorFetchingData'))
        });
      },

      ResolveMarkedStep() {
        var instance = this;
        TCVelikClient.PostRelative("/api/analytics/ResolveFlaggedStep?resolveComment=" + instance.resolveComment + "&stepId=" + instance.stepIdToResolve + "&notify_reporter=" + instance.notifyReporter).then(function (response) {
          if (response) {
            instance.flaggedItems
              .filter(x => x.OnboardingId === instance.stepOnboardingId)
              .forEach(x => {
                x.Items.splice(instance.stepIdToResolveIndex, 1);
              });
            instance.resolveComment = ""
            instance.InStepResolveMode = false;
            instance.stepIdToResolve = null
            instance.stepIdToResolveIndex = 0;
            instance.stepOnboardingId = 0;
            instance.notifyReporter = false;

          instance.$vs.notify({
            title: instance.$t('ResolvedStep'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
        }).catch(err => {
          instance.$vs.notify({
            title: instance.$t('ProblemResolvingStep'),
            color: "danger",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },

      LoadBlockedLatestSteps() {
        if (this.InEditFiltersMode == true) return 
        var instance = this;
        TCVelikClient.PostRelative("/api/analytics/GetLatestSteps?type=1", {
          SpaceIds: instance.selectedSpace, OnboardingIds: instance.selectedOnboarding, RoleIds: instance.selectedRole, Days: instance.date_range
        }).then(function (response) {
          if (response) {
            instance.flaggedItems = response.data || null
          }
        }).catch(err => {
          alert(this.$t('ErrorFetchingData'))
        });
      },

      LoadFeedbackStatisticsData() {
        if (this.InEditFiltersMode == true) return 
        var instance = this;
        TCVelikClient.PostRelative("/api/analytics/GetFeedbackStatisticsData", {
          SpaceIds: instance.selectedSpace, OnboardingIds: instance.selectedOnboarding, RoleIds: instance.selectedRole, Days: instance.date_range
        }).then(function (response) {
          if (response) {
            instance.feedbackData = response.data.FeedbackData || null
            //instance.timeSavedByOnboardings = response.data.TimeSaved || null
          }
        }).catch(err => {
          alert(this.$t('ErrorFetchingData'))
        });
      },

      LoadBlockedLatestOnboardings() {
        var instance = this;
        TCVelikClient.GetRelative("/api/analytics/GetLatestOnboardings").then(function (response) {
          if (response) {
            instance.latestCompletedOnboardings = response.data || null
            instance.filtedSelect = instance.latestCompletedOnboardings.filter((onboarding, index, self) => self.findIndex(o => o.OnboardingId === onboarding.OnboardingId) === index);
            instance.filtedOnboardings = instance.latestCompletedOnboardings;
          }
        }).catch(err => {
          alert("There was an error fetching the data.")
        });
      },
       LoadUserWithMostaCompletedOnboardings() {
        if (this.InEditFiltersMode == true) return 
        var instance = this;
        TCVelikClient.PostRelative("/api/analytics/GetUserWithMostaCompletedOnboardings", {
          SpaceIds: instance.selectedSpace, OnboardingIds: instance.selectedOnboarding, RoleIds: instance.selectedRole, Days: instance.date_range
        }).then(function (response) {
          if (response) {
            instance.mostCompletedOnboardings = response.data || null
          }
        }).catch(err => {
          alert("There was an error fetching the data.")
        });
      },
      LoadUsersAndRoles() {
        var instance = this;
        const query = `
          query RolesWithUsers {
                rolesWithUsers {
                    id
                    name,
                   }
            }`;
        const req = {
          query,
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response.data.data) {
            instance.rolesList = response.data.data.rolesWithUsers
          }
        }).catch(err => {
          alert(this.$t('ErrorFetchingData'))
        })
      },
      SaveSearchQuery() {
        const instance = this;
        const query = `
  mutation SaveAnalyticsQuery($entity: SavedAnalyticsQueryInput!) {
    saveAnalyticsQuery(entity: $entity) {
      id
      name
      url
      roleIds
      onboardingIds
      spaceIds,
      dateRange
    }
  }
`;

        const variables = {
          entity: {
            id: 0,
            name: this.query_name,
            url: this.query_url,
            roleIds: this.selectedRole,
            onboardingIds: this.selectedOnboarding,
            spaceIds: this.selectedSpace,
            dateRange:this.date_range
          }
        };

        const payload = {
          query,
          variables
        };

        TCVelikClient.PostRelative("/api/graphql", payload, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response) {
            instance.query_name = "";
            instance.query_url = "";
            instance.$vs.notify({
              title: instance.$t('SavedQuery'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
        }).catch(err => {
          instance.$vs.notify({
            title: instance.$t('ProblemSavingQuery'),
            color: "failure",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },
      DeleteSearchQuery() {
        const instance = this;
        const query = `
  mutation DeleteAnalyticsSeachQuery($url: String!) {
    deleteAnalyticsSeachQuery(url: $url) 
    
  }
`;

        const variables = {
          url: this.$route.params.slug
        };

        const payload = {
          query,
          variables
        };

        TCVelikClient.PostRelative("/api/graphql", payload, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response) {
            instance.$vs.notify({
              title: instance.$t('DeletedQuery'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
            setTimeout(() => {
              instance.$router.replace('/pages/analyticsOverview');
              window.location.reload();
            }, 1000);
          }
        }).catch(err => {
          instance.$vs.notify({
            title: instance.$t('ProblemSavingQuery'),
            color: "failure",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },
      EditSearchQuery() {
        const instance = this;
        const query = `
mutation EditAnalyticsSeachQuery($url:String!,$name:String!,$newUrl:String!) {
    editAnalyticsSeachQuery(url: $url, name: $name, newUrl: $newUrl)
}
`;

        const variables = {
          url: this.$route.params.slug,
          name: this.query_name,
          newUrl:this.query_url
        };

        const payload = {
          query,
          variables
        };

        TCVelikClient.PostRelative("/api/graphql", payload, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (!response.errors) {
            instance.$vs.notify({
              title: instance.$t('SavedChangesGeneric'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
            setTimeout(() => {
              instance.$router.push({ params: { slug: instance.query_url } });
              window.location.reload();
            }, 1000);
          }
        }).catch(err => {
          instance.$vs.notify({
            title: "A problem occurred while attempting to save your query.",
            color: "failure",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },

        EditSearchQueryFilters() {
            const instance = this;
            const query = `
mutation EditAnalyticsSeachQueryFilters($url:String!,$roleIds:[String!]!, $onboardingIds:[Int!]!,$spaceIds:[Int!]!,$dateRange:Int!) {
    editAnalyticsSeachQueryFilters(url: $url,  roleIds: $roleIds,onboardingIds: $onboardingIds,spaceIds: $spaceIds,dateRange:$dateRange){
       
    }
}
`;

            const variables = {
                url: this.$route.params.slug,
                onboardingIds: instance.selectedOnboarding,
                spaceIds: instance.selectedSpace,
                roleIds: instance.selectedRole,
                dateRange: instance.date_range
            };

            const payload = {
                query,
                variables
            };

            TCVelikClient.PostRelative("/api/graphql", payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            }).then(function (response) {
                if (!response.errors) {
                    instance.InEditFiltersMode = false;
                    instance.$vs.notify({
                        title: "Saved changes.",
                        color: "success",
                        iconPack: "feather",
                        position: "top-center",
                        icon: "icon-check-circle",
                    });
                    instance.LoadHeatMapAndMetricsData();
                }
            }).catch(err => {
                instance.InEditFiltersMode = false;
                instance.$vs.notify({
                    title: instance.$t('ProblemSavingFilters'),
                    color: "failure",
                    iconPack: "feather",
                    position: "top-center",
                    icon: "icon-check-circle",
                });
            });
        },


      LoadSeachQuery() {
        var instance = this;
        var query =
          `query SavedAnalyticsQuery($url: String!) {
    savedAnalyticsQuery(where: { url: { eq: $url } }) {
         roleIds,
         onboardingIds,
         spaceIds,
         dateRange,
         name
    }
}`
        const req = {
          query,
          variables: {
            url: this.$route.params.slug,
          }
        };
        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response) {
            const savedQuery = response.data.data.savedAnalyticsQuery[0];

            // Find onboarding objects by ID and set selections
            instance.selectedOnboarding.push(...savedQuery.onboardingIds)
            instance.queryName = savedQuery.name
            // Convert space IDs to objects
            instance.selectedSpace.push(...savedQuery.spaceIds)
            instance.selectedRole.push(...savedQuery.roleIds)
            instance.date_range = savedQuery.dateRange
            instance.LoadHeatMapAndMetricsData();
          }
        })
      },
      OpenSaveSearchQuery() {
        this.InSaveQueryMode = true
      },
      LoadSpaces() {
        var instance = this;
        const query = `
          query Spaces {
              spaces {
                  id
                  title,
                  rootId,
                  parentId
              }
          }`;
        const req = {
          query,
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response.data.data) {
            instance.tempSpaceList = response.data.data.spaces
            instance.spaceList = response.data.data.spaces.map(item => {
              return {
                ...item,               // Spread the existing properties of `item`
                breadcrumbTile: instance.GetBreadcrumb(item)   // Add the new property
              };
            });
          }
        }).catch(err => {
          alert("There was an error fetching the spaces.")
        })
      },

      LoadOnboardings() {
        var instance = this;
        const query = `
    query Onboardings {
    onboardings {
        id
        name
        description
    }
}`;
        const req = {
          query,
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response.data.data) {
            instance.onboardingList = response.data.data.onboardings
          }
        }).catch(err => {
          alert("There was an error fetching the spaces.")
        })
      },

      getFriendlyUserName(userNameCandidate) {
        if (userNameCandidate.FirstName != null && userNameCandidate.LastName.length > 0) {
          let firstNamePart = userNameCandidate.FirstName[0];
          let secondNamePart = userNameCandidate.LastName[0];
          firstNamePart.replace(/\b\w/g, char => char.toUpperCase());
          secondNamePart.replace(/\b\w/g, char => char.toUpperCase());
          return firstNamePart + secondNamePart;
        }
        // Remove domain part if '@' is present
        let namePart = userNameCandidate.UserName.split('@')[0];

        // Replace '.' with ' '
        namePart = namePart.replace(/\./g, ' ');

        // Capitalize first letters
        namePart = namePart.replace(/\b\w/g, char => char.toUpperCase());

        return namePart;
      },
      OpenStepResolveMenu(stepId, index, onboardingId) {
        this.InStepResolveMode = true;
        this.stepIdToResolve = stepId
        this.stepIdToResolveIndex = index
        this.stepOnboardingId = onboardingId
      },


      moment(dateString) {
        const moment = require("moment");
        return moment(dateString).fromNow();
      },
      async loadDocumentationRequests() {
        // Use the selected date range or default to 30 days
        const days = this.date_range || 30;
        try {
          const response = await TCVelikClient.GetRelative(`/api/analytics/GetDocumentationRequestStats?days=${days}`);
          
          if (response && response.data) {
            const data = response.data;
            this.documentationRequests = data.NumberOfRequests;
          }
        } catch (e) {
          this.documentationRequests = 0;
        }
      },
    }
  }
</script>

<style>
  .vs-table--tbody {
    overflow: hidden !important;
    max-width: 100%;
  }

  .tcv-pageAnalytics .router-view {
    background: white;
  }

  .metrics-grid {
    margin-top: 20px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
    margin-bottom: 30px;
  }

  .metrics-chart {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  }

  .charts-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    gap: 20px;
    margin-bottom: 30px;
  }

  .step-box {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    margin-top: 20px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  }

  .step-box-inner {
    display: none;
    background: #ffffff;
    border-radius: 16px;
    padding: 10px;
    margin-top: 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
  }

  .expanded .step-box-inner {
    display: block;
  }

  .expanded .chevron-down {
    display: none;
  }

  .expandTools .chevron-up {
    display: none;
  }

  .expanded .chevron-up {
    display: block;
  }

  .icon-button {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    background: transparent;
    color: var(--neutral);
    cursor: pointer;
  }

    .icon-button:hover {
      background: var(--neutral-light);
      border-radius: 50%;
    }

  .grid-bottom {
    display: grid;
    grid-template-columns: 1fr 1fr; 
    gap: 10px; 
  }

  @media (max-width: 768px) { 
    .grid-bottom {
      grid-template-columns: 1fr; 
    }
  }

  /*body {
      background: #fff;
      padding: 20px;
    }*/
</style>
